import axiosInstance from "../axiosInstance";

/* ================= GET ================= */
export const getNotification = async () => {
  try {
    const res = await axiosInstance.get("/api/admin/notification/get");
    return {
      success: true,
      data: res.data.data,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to fetch notifications",
    };
  }
};

/* ================= ADD ================= */
export const addNotification = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/api/admin/notification/add",
      payload
    );
    return {
      success: true,
      data: res.data.data,
      message: "Notification added successfully",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to add notification",
    };
  }
};

/* ================= UPDATE ================= */
export const updateNotification = async (id, payload) => {
  try {
    const res = await axiosInstance.put(
      `/api/admin/notification/update/${id}`,
      payload
    );
    return {
      success: true,
      data: res.data.data,
      message: "Notification updated successfully",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to update notification",
    };
  }
};

/* ================= STATUS ================= */
export const deleteNotification = async (id) => {
  try {
    const res = await axiosInstance.delete(
      `/api/admin/notification/${id}`
    );
    return {
      success: true,
      data: res.data.data,
      message: res.data?.message || "Notification deleted",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message || "Failed to delete notification",
    };
  }
};

export const toggleNotificationStatus = async (id) => {
  try {
    const res = await axiosInstance.patch(
      `/api/admin/notification/status/${id}`
    );
    return {
      success: true,
      data: res.data.data,
      message: "Status updated successfully",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to update status",
    };
  }
};
